<template>
  <apexchart
    type="area"
    height="250"
    :options="chartOptions"
    :series="series"
  />
</template>

<script>
export default {
  props: {
    labels: Array,
    propsData: Array,
    exchangesData: Array
  },

  computed: {
    series() {
      return [
        { name: 'عقارات جديدة', data: this.propsData },
        { name: 'طلبات التقبيل', data: this.exchangesData }
      ];
    },
    chartOptions() {
      return {
        chart: { toolbar: { show: false }, fontFamily: 'Nohemi, IBM Plex Sans Arabic, sans-serif' },
        colors: ['#3e572e', '#a69057'],
        xaxis: {
          categories: this.labels,
          labels: { style: { colors: '#7a8276', fontSize: '11px' } },
          axisBorder: { color: '#dde5d7' },
          axisTicks: { color: '#dde5d7' }
        },
        yaxis: { labels: { style: { colors: '#7a8276', fontSize: '11px' } } },
        stroke: { curve: 'smooth', width: 3 },
        fill: {
          type: 'gradient',
          gradient: { opacityFrom: .28, opacityTo: .03, stops: [0, 95, 100] }
        },
        grid: { borderColor: '#edf1e9', strokeDashArray: 4 },
        dataLabels: { enabled: false },
        tooltip: { theme: 'light' }
      };
    }
  }
};
</script>
